import { createSlice } from '@reduxjs/toolkit';
import { api, apis, mailPerfTool, } from 'api';
import { MailActions } from '.';
import { SIGN_SELECT_STATUS } from '../state';
import { MailBoxExtraReducers, MailBoxInitialState, MailBoxSlice, MailBoxThunks } from '@web-mail/state/slice/mailReducer/mailReducer';
const contactApi = api.requireLogicalApi(apis.contactApiImpl);
const mailApi = api.requireLogicalApi(apis.mailApiImpl);
const dataStoreApi = api.getDataStoreApi();
const systemApi = api.getSystemApi();
const InitialState = Object.assign({ selectedCustomerTab: 'MY_CUSTOMER', mails: [], currentMail: {}, waittingMailIds: [], replyExpandedId: '', forbidSaveTemp: false, showWebWriteLetter: false, receivers: [], subject: '', selectSign: SIGN_SELECT_STATUS.UNINITIALIZED, selector: {
        focused: '',
        add: false,
        pendingItem: null,
    }, editorTooltip: {
        top: -999,
        left: 0,
        title: '',
    }, cacheAttachment: {}, applyGenerateHide: () => { }, sendingMails: [], tooltipVisible: false, wirteMailSpin: false, errModalData: {
        errorDoc: '',
        errorText: '',
        isSimpleTooltip: false,
        showCheckbox: false,
        checkboxText: '',
        checkboxChecked: false,
    }, writeMailStatus: '', attPasteable: true }, MailBoxInitialState);
const replaceCertainMail = (mails, currentMail) => mails.map(mail => (mail.cid === currentMail.cid ? currentMail : mail));
export const isChangeCurrentMailAction = (action) => {
    const targetActions = Object.keys(MailActions).map(actionName => `${mailSlice.name}/${actionName}`);
    return targetActions.includes(action.type);
};
export const getVailMailContact = (cur, pre) => {
    const curContact = cur.contact.contact;
    const preContact = pre.contact.contact;
    if (curContact.type === 'enterprise') {
        return cur;
    }
    if (preContact.type === 'enterprise') {
        return pre;
    }
    return curContact.id.toString().localeCompare(preContact.id.toString(), 'zh') >= 0 ? cur : pre;
};
export const MailContactUniqueMap = (list, receiverType) => {
    const contactMap = new Map();
    list.forEach(item => {
        if (typeof item !== 'string') {
            const email = contactApi.doGetModelDisplayEmail(item.contact);
            const cur = contactMap.get(email);
            if (cur) {
                contactMap.set(email, getVailMailContact(cur, item));
            }
            else {
                contactMap.set(email, item);
            }
        }
        else {
            if (!contactMap.get(item)) {
                contactMap.set(item, mailApi.buildRawContactItem({
                    item,
                    email: item,
                    type: receiverType,
                }));
            }
        }
    });
    return contactMap;
};
export const MailContactUnique = (list, receiverType) => {
    return [...MailContactUniqueMap(list, receiverType).values()];
};
export const MailContactDel = (list, delList, receiverType) => {
    const originMap = MailContactUniqueMap(list, receiverType);
    const delMap = MailContactUniqueMap(delList, receiverType);
    delMap.forEach((_value, key) => {
        if (originMap.has(key)) {
            originMap.delete(key);
        }
    });
    return [...originMap.values()];
};
const mailSlice = createSlice({
    name: 'mailReducer',
    initialState: InitialState,
    reducers: Object.assign({ doChangeExtraOperateDone: (state, action) => {
            state.mails = state.mails.map(mail => {
                if (mail.cid === action.payload) {
                    mail.extraOperateDone = true;
                }
                return mail;
            });
            if (state.currentMail.cid === action.payload) {
                state.currentMail = Object.assign(Object.assign({}, state.currentMail), { extraOperateDone: true });
            }
        }, setApplyGenerateHide: (state, action) => {
            state.applyGenerateHide = action.payload;
        }, doReplyChangeExpanded: (state, action) => {
            state.replyExpandedId = action.payload;
        }, doCloseMail: (state, action) => {
            state.mails = state.mails.filter(item => item.cid !== action.payload);
            const index = state.mails.findIndex(item => item.cid === action.payload);
            if (state.mails[index + 1]) {
                state.currentMail = state.mails[index + 1];
                return;
            }
            if (state.mails[index - 1]) {
                state.currentMail = state.mails[index + 1];
                return;
            }
            state.currentMail = InitialState.currentMail;
            return;
        }, doClearMails: (state, action) => {
            const filteredMails = [];
            state.mails.forEach(item => {
                if (item.cid && !action.payload.includes(item.cid)) {
                    filteredMails.push(item);
                }
            });
            state.mails = filteredMails;
        }, doClearAllMails: state => {
            state.mails = [];
        }, doWriteMail: (state, action) => {
            var _a, _b, _c;
            const mailEntry = action.payload;
            const { receiver, entry, sender, _account } = mailEntry;
            mailEntry.receiver = receiver.filter(_ => (_ === null || _ === void 0 ? void 0 : _.originName) !== '无收件人');
            mailEntry.selectSign = SIGN_SELECT_STATUS.UNINITIALIZED;
            if (entry.isScheduleSend) {
                if (mailEntry.entry.sendTime) {
                    try {
                        mailEntry.scheduleDate = (_b = systemApi
                            .timeZoneTrans(mailEntry.entry.sendTime, -(new Date().getTimezoneOffset() / 60), ((_a = systemApi.getSystemTimeZone()) === null || _a === void 0 ? void 0 : _a.key) || 8)) === null || _b === void 0 ? void 0 : _b.format('YYYY-MM-DD HH:mm');
                        mailEntry.scheduleDateTimeZone = ((_c = systemApi.getSystemTimeZone()) === null || _c === void 0 ? void 0 : _c.key) || 8;
                    }
                    catch (error) {
                        console.log('设置时区失败', error);
                    }
                }
            }
            mailEntry.initSenderStr = _account || sender.contactItem.contactItemVal;
            const lxWriteRemind = dataStoreApi.getSync('lxWriteRemind', { noneUserRelated: true });
            mailEntry.senderReceivers = lxWriteRemind.suc && lxWriteRemind.data === 'true';
            state.mails.push(mailEntry);
            state.currentMail = mailEntry;
            mailPerfTool.writeMail('end', { writeType: action.payload.writeType });
        }, doSetSelectSign: (state, action) => {
            state.currentMail.selectSign = action.payload;
        }, doSetWaittingMailIds: (state, action) => {
            const { payload } = action;
            state.waittingMailIds = payload;
        }, doSetTooltipVisible: (state, action) => {
            state.tooltipVisible = action.payload;
        }, doSetWirteMailSpin: (state, action) => {
            state.wirteMailSpin = action.payload;
        }, doSetErrModalData: (state, action) => {
            state.errModalData = action.payload;
        }, doCoverErrModalData: (state, action) => {
            state.errModalData = Object.assign(Object.assign(Object.assign({}, state.errModalData), { errorDoc: '' }), action.payload);
        }, doRemErrModalDataFun: (state, action) => {
            state.errModalData = Object.assign(Object.assign({}, state.errModalData), { continueCallback: action.payload, cancelCallback: action.payload });
        }, doAddWaittingMailIds: (state, action) => {
            const { payload } = action;
            state.waittingMailIds = Array.from(new Set([...state.waittingMailIds, ...payload]));
        }, doRemWaittingMailId: (state, action) => {
            const { payload } = action;
            if (payload) {
                state.waittingMailIds = state.waittingMailIds.filter(id => id !== payload);
            }
        }, setResetCont: (state, action) => {
            state.currentMail = Object.assign(Object.assign({}, state.currentMail), { resetCont: action.payload });
        }, doShowWebWrite: (state, action) => {
            state.showWebWriteLetter = action.payload;
        }, doModifySubject: (state, action) => {
            state.currentMail.entry.title = action.payload;
        }, doUnfinishImgCount: (state, action) => {
            let count = state.currentMail.unfinishImgCount || 0;
            count += action.payload;
            state.currentMail.unfinishImgCount = count;
        }, doFocusTitle: (state, action) => {
            state.currentMail.focusTitle = action.payload;
        }, doModifyOptSender: (state, action) => {
            state.currentMail.optSender = Object.assign({}, action.payload);
            state.currentMail.selectSign = SIGN_SELECT_STATUS.UNINITIALIZED;
        }, doModifyDefaultSign: (state, action) => {
            if (state.currentMail.cid === action.payload.cid) {
                state.currentMail.defaultSign = action.payload.sign;
            }
            if (action.payload.cid) {
                const targetIndex = state.mails.findIndex(item => item.cid === action.payload.cid);
                state.mails[targetIndex].defaultSign = action.payload.sign;
            }
        }, doModifyMailEditStatus: (state, action) => {
            const { cid, status } = action.payload;
            if (state.currentMail.cid === cid) {
                state.currentMail.mailEditStatus = status;
            }
            state.mails = state.mails.map(mail => {
                if (mail.cid === cid) {
                    return Object.assign(Object.assign({}, mail), { mailEditStatus: status });
                }
                return mail;
            });
        }, doModifySender: (state, action) => {
            state.currentMail.sender = Object.assign({}, action.payload);
        }, doModifyOptSenderMainEmail: (state, action) => {
            state.currentMail.optSenderMainEmail = action.payload;
        }, doModifyInitSenderStr: (state, action) => {
            state.currentMail.initSenderStr = action.payload;
        }, doModifyCurMailExpired: (state, action) => {
            state.currentMail.subAccountExpired = action.payload;
        }, doModifySubAccountExpired: (state, action) => {
            const { email, expired } = action.payload;
            state.mails = state.mails.map(mail => {
                if (mail.initSenderStr === email) {
                    return Object.assign(Object.assign({}, mail), { subAccountExpired: expired });
                }
                return mail;
            });
            if (state.currentMail.initSenderStr === email) {
                state.currentMail.subAccountExpired = expired;
            }
        }, doAddSendingMails: (state, action) => {
            state.sendingMails = [...state.sendingMails, action.payload];
        }, doRemoveSendingMail: (state, action) => {
            state.sendingMails = state.sendingMails.filter(item => item.id !== action.payload);
        }, doUpdateSendingMails: (state, action) => {
            state.sendingMails = action.payload;
        }, doModifyReceiver: (state, action) => {
            var _a, _b;
            const { receiver, receiverType, operation } = action.payload;
            if (operation === 'paste') {
                const unModifed = state.currentMail.receiver.filter(r => r.mailMemberType !== receiverType);
                const filtered = state.currentMail.receiver
                    .filter(r => r.mailMemberType === receiverType);
                const uniqueList = MailContactUnique([...filtered, ...receiver], receiverType);
                uniqueList.forEach(item => (item.mailMemberType = receiverType));
                state.currentMail.receiver = [...unModifed, ...uniqueList];
                return;
            }
            if (operation === 'delete') {
                const unModifed = state.currentMail.receiver.filter(r => r.mailMemberType !== receiverType);
                const filtered = state.currentMail.receiver
                    .filter(r => r.mailMemberType === receiverType);
                state.currentMail.receiver = [...unModifed, ...MailContactDel(filtered, receiver, receiverType)];
                return;
            }
            let filteredReceiver = ((_b = (_a = state.currentMail) === null || _a === void 0 ? void 0 : _a.receiver) === null || _b === void 0 ? void 0 : _b.filter(item => item && item.mailMemberType !== receiverType)) || [];
            filteredReceiver = state.currentMail.isOneRcpt ? [] : filteredReceiver;
            state.currentMail.receiver = [...filteredReceiver, ...MailContactUnique(receiver, receiverType)];
        }, doReplaceReceiver: (state, action) => {
            state.currentMail.receiver = [...action.payload];
        }, doChangeNoPrompt: (state, action) => {
            state.currentMail.noPrompt = action.payload;
        }, doReplaceCid: (state, action) => {
            const { payload } = action;
            const { cid, newCid, _account, con, mailEditStatus } = payload;
            const targetIndex = state.mails.findIndex(item => item.cid === cid);
            state.mails[targetIndex] = Object.assign(Object.assign(Object.assign({}, state.mails[targetIndex]), (mailEditStatus || mailEditStatus === '' ? { mailEditStatus } : {})), { cid: newCid, _account });
            if (con)
                state.mails[targetIndex].entry.content.content = con;
            if (state.currentMail.cid === cid) {
                state.currentMail = Object.assign(Object.assign(Object.assign({}, state.currentMail), (mailEditStatus || mailEditStatus === '' ? { mailEditStatus } : {})), { cid: newCid, _account });
                if (con)
                    state.currentMail.entry.content.content = con;
            }
        }, doChangeMailContent: (state, action) => {
            try {
                state.currentMail.entry.content.content = action.payload;
                state.currentMail.entry.withoutPlaceholder = true;
            }
            catch (ex) {
                console.error('doChangeMailContent', ex);
            }
        }, doChangeMailScrollBoxTop: (state, action) => {
            state.currentMail.scrollBoxTop = action.payload;
        }, doChangeCurrentMail: (state, action) => {
            const { payload } = action;
            let val = payload;
            state.currentMail = state.mails.find(item => item.cid === val);
        }, doChangeMail: (state, action) => {
            const { payload } = action;
            const { cid } = payload;
            const targetIndex = state.mails.findIndex(item => item.cid === cid);
            state.mails[targetIndex] = payload;
            if (state.currentMail.cid === cid) {
                state.currentMail = payload;
            }
        }, doChangeMailDraftId: (state, action) => {
            const { payload } = action;
            const { cid, draftId, _id } = payload;
            const targetIndex = state.mails.findIndex(item => item.cid === cid);
            state.mails[targetIndex].draftId = draftId;
            state.mails[targetIndex]._id = _id;
            if (state.currentMail.cid === cid) {
                state.currentMail.draftId = draftId;
                state.mails[targetIndex]._id = _id;
            }
        }, doReplaceMail: (state, action) => {
            const { payload } = action;
            const { recoverCid } = payload;
            const targetIndex = state.mails.findIndex(item => item.cid === recoverCid);
            if (targetIndex < 0)
                return;
            const mergedRes = Object.assign(Object.assign({}, state.mails[targetIndex]), payload);
            state.mails[targetIndex] = mergedRes;
            if (state.currentMail.cid === recoverCid) {
                state.currentMail = Object.assign(Object.assign({}, state.currentMail), payload);
            }
        }, doResetCurrentMail: state => {
            state.currentMail = {};
        }, doChangeMailInfoStatus: (state, action) => {
            state.currentMail.status = action.payload;
        }, doShowWriteContact: (state, action) => {
            var _a;
            if (!((_a = state === null || state === void 0 ? void 0 : state.currentMail) === null || _a === void 0 ? void 0 : _a.status))
                return;
            if (action.payload) {
                state.currentMail.status.userBusyFreeShow = false;
                state.currentMail.status.sensitiveTipShow = false;
            }
            state.currentMail.status.showContact = action.payload;
        }, doShowSensitiveTip: (state, action) => {
            var _a;
            if (!((_a = state === null || state === void 0 ? void 0 : state.currentMail) === null || _a === void 0 ? void 0 : _a.status))
                return;
            if (action.payload) {
                state.currentMail.status.showContact = false;
                state.currentMail.status.userBusyFreeShow = false;
            }
            state.currentMail.status.sensitiveTipShow = action.payload;
        }, doShowUserBusyFree: (state, action) => {
            var _a;
            if (!((_a = state === null || state === void 0 ? void 0 : state.currentMail) === null || _a === void 0 ? void 0 : _a.status))
                return;
            if (action.payload) {
                state.currentMail.status.showContact = false;
            }
            state.currentMail.status.userBusyFreeShow = action.payload;
        }, doAfterInit: (state, action) => {
            var _a;
            if (!((_a = state === null || state === void 0 ? void 0 : state.currentMail) === null || _a === void 0 ? void 0 : _a.status))
                return;
            state.currentMail.status.init = action.payload;
        }, doConferenceSettting: (state, action) => {
            var _a;
            if (!((_a = state === null || state === void 0 ? void 0 : state.currentMail) === null || _a === void 0 ? void 0 : _a.status))
                return;
            state.currentMail.status.conferenceSetting = action.payload;
        }, doConferenceChange: (state, action) => {
            state.currentMail.conference = action.payload;
        }, doConferenceUploadChange: (state, action) => {
            const { cid, uploadSuc } = action.payload;
            if (state.currentMail.cid === cid && state.currentMail.conference) {
                state.currentMail.conference.uploadSuc = uploadSuc;
            }
            state.mails = state.mails.map(mail => {
                if (mail.cid === cid && mail.conference) {
                    mail.conference.uploadSuc = uploadSuc;
                    return Object.assign({}, mail);
                }
                return mail;
            });
        }, doMailContentSize: (state, action) => {
            state.currentMail.mailContentSize = action.payload;
        }, doConferenceShow: (state, action) => {
            var _a;
            if (!((_a = state === null || state === void 0 ? void 0 : state.currentMail) === null || _a === void 0 ? void 0 : _a.status))
                return;
            state.currentMail.status.conferenceShow = action.payload;
        }, doPraiseShow: (state, action) => {
            var _a;
            if (!((_a = state === null || state === void 0 ? void 0 : state.currentMail) === null || _a === void 0 ? void 0 : _a.status))
                return;
            state.currentMail.status.praiseMailShow = action.payload;
        }, doCCShow: (state, action) => {
            var _a;
            if (!((_a = state === null || state === void 0 ? void 0 : state.currentMail) === null || _a === void 0 ? void 0 : _a.status))
                return;
            state.currentMail.status.cc = action.payload;
        }, doBCCShow: (state, action) => {
            var _a;
            if (!((_a = state === null || state === void 0 ? void 0 : state.currentMail) === null || _a === void 0 ? void 0 : _a.status))
                return;
            state.currentMail.status.bcc = action.payload;
        }, doPraiseMailSetting: (state, action) => {
            var _a;
            if (!((_a = state === null || state === void 0 ? void 0 : state.currentMail) === null || _a === void 0 ? void 0 : _a.status))
                return;
            state.currentMail.status.praiseMailSetting = action.payload;
        }, doPraiseMailChange: (state, action) => {
            state.currentMail.praiseMail = action.payload;
        }, doMailImgSizeChange: (state, action) => {
            const orgCount = state.currentMail.mailImgSize || 0;
            if (action.payload.type === 'cover') {
                state.currentMail.mailImgSize = action.payload.count;
            }
            else {
                state.currentMail.mailImgSize = orgCount + action.payload.count;
            }
        }, doTaskShow: (state, action) => {
            if (!state.currentMail.status)
                return;
            state.currentMail.status.taskMailShow = action.payload;
        }, doSetPuretext: (state, action) => {
            if (!state.currentMail.status)
                return;
            state.currentMail.status.puretext = action.payload;
        }, doTaskMailSetting: (state, action) => {
            var _a;
            if (!((_a = state === null || state === void 0 ? void 0 : state.currentMail) === null || _a === void 0 ? void 0 : _a.status))
                return;
            state.currentMail.status.taskMailSetting = action.payload;
        }, doUseVariable: (state, action) => {
            var _a;
            if (!((_a = state === null || state === void 0 ? void 0 : state.currentMail) === null || _a === void 0 ? void 0 : _a.status))
                return;
            state.currentMail.status.useVariable = action.payload;
        }, doTaskMailChange: (state, action) => {
            state.currentMail.taskMail = action.payload;
        }, doChangeEditorTooltip: (state, action) => {
            state.editorTooltip = action.payload;
        }, doChangeMailScheduleTimeZone: (state, action) => {
            const payload = action.payload;
            if (typeof payload === 'object') {
                state.mails = state.mails.map(mail => {
                    if (mail.cid === payload.cid) {
                        mail.scheduleDateTimeZone = payload.scheduleDateTimeZone;
                    }
                    return mail;
                });
                if (state.currentMail.cid === payload.cid) {
                    state.currentMail.scheduleDateTimeZone = payload.scheduleDateTimeZone;
                }
                return;
            }
            else {
                state.currentMail.scheduleDateTimeZone = action.payload;
                return;
            }
        }, doChangeMailIsEncryptedMail: (state, action) => {
            state.currentMail.isEncryptedMail = action.payload;
        }, doChangeMailSetEncrypt: (state, action) => {
            state.currentMail.setEncrypt = action.payload;
        }, doChangeMailEncpwd: (state, action) => {
            state.currentMail.entry.encpwd = action.payload;
        }, doChangeMailSavePassword: (state, action) => {
            state.currentMail.savePassword = action.payload;
        }, doChangeMailSchedule: (state, action) => {
            const payload = action.payload;
            if (typeof payload === 'object') {
                state.mails = state.mails.map(mail => {
                    if (mail.cid === payload.cid) {
                        mail.scheduleDate = payload.scheduleDate;
                    }
                    return mail;
                });
                if (state.currentMail.cid === payload.cid) {
                    state.currentMail.scheduleDate = payload.scheduleDate;
                }
                return;
            }
            else {
                state.currentMail.scheduleDate = payload;
                return;
            }
        }, doChangeMailEmergency: (state, action) => {
            state.currentMail.entry.priority = action.payload;
        }, doChangeRequestReadReceipt: (state, action) => {
            state.currentMail.requestReadReceipt = action.payload;
        }, doChangeMailReadRemind: (state, action) => {
            state.currentMail.senderReceivers = action.payload;
        }, doSetWriteMailStatus: (state, action) => {
            state.writeMailStatus = action.payload;
        }, doDeleteMailById: (state, action) => {
            const index = state.mailDataList.findIndex(id => id === action.payload);
            const nextMailId = state.mailDataList[index + 1] ? state.mailDataList[index + 1] : state.mailDataList[index - 1];
            state.mailDataList = state.mailDataList.filter(id => id !== action.payload);
            state.activeIds = nextMailId ? [nextMailId] : [];
            state.selectedMailId.id = nextMailId || '';
        }, doChangeMailOneRcpt: (state, action) => {
            state.currentMail.isOneRcpt = action.payload;
        }, doChangeDyncGroupSend: (state, action) => {
            state.currentMail.isDyncGroupSend = action.payload;
        }, doChangeContactVariables: (state, action) => {
            state.currentMail.contactVariables = action.payload;
        }, doClearDyncGroupSendStatus: state => {
            var _a;
            const curStatus = (_a = state.currentMail) === null || _a === void 0 ? void 0 : _a.status;
            if (curStatus) {
                delete curStatus['dynGroupSendStatus'];
                state.currentMail.status = curStatus;
            }
        }, doChangeDyncGroupSendStatus: (state, action) => {
            var _a, _b, _c;
            const data = Object.assign(Object.assign({}, (((_b = (_a = state.currentMail) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.dynGroupSendStatus) || {})), action.payload);
            state.currentMail.status = Object.assign(Object.assign({}, (((_c = state.currentMail) === null || _c === void 0 ? void 0 : _c.status) || {})), { dynGroupSendStatus: data });
        }, doChangeDyncGroupSendPreview: (state, action) => {
            state.dyncGroupSendPreview = Object.assign(Object.assign({}, state.dyncGroupSendPreview), action.payload);
        }, doUpdateForbidSaveTemp(state, action) {
            state.forbidSaveTemp = action.payload;
        },
        doChangeCacheAttachment(state, action) {
            var _a, _b, _c, _d;
            const { id, type, value, operationType, originFileUrl, localPath, newName } = action.payload;
            if (operationType === 'delete' && !value) {
                delete state.cacheAttachment[id];
            }
            else if (operationType === 'delete' && value && type === 'inlineImg') {
                ((_a = state.cacheAttachment[id]) === null || _a === void 0 ? void 0 : _a.attachment) &&
                    (state.cacheAttachment[id].attachment = state.cacheAttachment[id].attachment.filter(file => {
                        if (file.type === 'inlineImg' && value === file.originFileUrl) {
                            return false;
                        }
                        return true;
                    }));
            }
            else if (operationType === 'delete' && value) {
                const fileid = value.id;
                ((_b = state.cacheAttachment[id]) === null || _b === void 0 ? void 0 : _b.attachment) &&
                    (state.cacheAttachment[id].attachment = state.cacheAttachment[id].attachment.filter(file => {
                        const onid = file.value.id;
                        return fileid !== onid;
                    }));
            }
            else if (operationType === 'add' && type && value) {
                let addValue = [];
                if (Array.isArray(value)) {
                    addValue = value.map(_ => {
                        return { type, value: _, originFileUrl, localPath };
                    });
                }
                else {
                    addValue = [{ type, value, originFileUrl, localPath }];
                }
                if (state.cacheAttachment[id]) {
                    state.cacheAttachment[id].attachment = state.cacheAttachment[id].attachment.concat(addValue);
                }
                else {
                    state.cacheAttachment[id] = { id, attachment: addValue };
                }
            }
            else if (operationType === 'localPathChange' && localPath) {
                const fileid = value.realId || value.id;
                ((_c = state.cacheAttachment[id]) === null || _c === void 0 ? void 0 : _c.attachment) &&
                    state.cacheAttachment[id].attachment.forEach(file => {
                        const onid = file.value.realId || file.value.id;
                        if (fileid === onid) {
                            file.localPath = localPath;
                        }
                    });
            }
            else if (operationType === 'rename' && newName) {
                const fileid = value.realId || value.id;
                ((_d = state.cacheAttachment[id]) === null || _d === void 0 ? void 0 : _d.attachment) &&
                    state.cacheAttachment[id].attachment.forEach(file => {
                        var _a, _b, _c, _d, _e, _f;
                        const onid = file.value.realId || file.value.id;
                        const fileType = file.type;
                        if (fileid === onid) {
                            if (fileType === 'localFile') {
                                file.value.fileName = newName;
                                const originalPath = ((_b = (_a = file === null || file === void 0 ? void 0 : file.value) === null || _a === void 0 ? void 0 : _a.file) === null || _b === void 0 ? void 0 : _b.path) || ((_c = file === null || file === void 0 ? void 0 : file.value) === null || _c === void 0 ? void 0 : _c.originalPath) || '';
                                const newFile = new File([file.value.file], newName, {
                                    type: file.value.file.type,
                                    lastModified: file.value.file.lastModified,
                                });
                                file.value.file = newFile;
                                file.value.originalPath = originalPath;
                            }
                            if (fileType === 'localCloudFile') {
                                file.value.fileName = newName;
                                const originalPath = ((_e = (_d = file === null || file === void 0 ? void 0 : file.value) === null || _d === void 0 ? void 0 : _d.file) === null || _e === void 0 ? void 0 : _e.path) || ((_f = file === null || file === void 0 ? void 0 : file.value) === null || _f === void 0 ? void 0 : _f.originalPath) || '';
                                const newFile = new File([file.value.file], newName, {
                                    type: file.value.file.type,
                                    lastModified: file.value.file.lastModified,
                                });
                                file.value.file = newFile;
                                file.value.originalPath = originalPath;
                            }
                            if (fileType === 'diskFile') {
                                file.value.fileName = newName;
                            }
                            if (fileType === 'diskCloudFile') {
                                file.value.fileName = newName;
                            }
                            if (fileType === 'diskNormalFile') {
                                file.value.fileName = newName;
                            }
                            if (fileType === 'originalCloudFile') {
                                file.value.fileName = newName;
                            }
                            if (fileType === 'originalFile') {
                                file.value.fileName = newName;
                            }
                            if (fileType === 'forwardAsAttach') {
                                file.value.fileName = newName;
                            }
                        }
                    });
            }
        },
        doReplaceCacheAttachment(state, action) {
            const { oldCid, newCid } = action.payload;
            if (state.cacheAttachment[oldCid]) {
                state.cacheAttachment[newCid] = {
                    id: newCid,
                    attachment: state.cacheAttachment[oldCid].attachment || [],
                };
            }
            delete state.cacheAttachment[oldCid];
        },
        doUpdateSelectedCustomerTab(state, action) {
            state.selectedCustomerTab = action.payload;
        },
        doUpdateAttPasteable(state, action) {
            state.attPasteable = action.payload;
        },
        doUpdateWaitSave(state, action) {
            const payload = action.payload;
            state.mails = state.mails.map(mail => {
                if (mail.cid === payload.cid) {
                    mail.waitSave = payload.val;
                }
                return mail;
            });
            if (state.currentMail.cid === payload.cid) {
                state.currentMail.waitSave = payload.val;
            }
            return;
        } }, MailBoxSlice),
    extraReducers: builder => {
        MailBoxExtraReducers(builder);
        builder.addMatcher(isChangeCurrentMailAction, state => {
            if (state.currentMail) {
                state.mails = replaceCertainMail(state.mails, state.currentMail);
            }
        });
    },
});
export const Thunks = Object.assign({}, MailBoxThunks);
export const { actions } = mailSlice;
export default mailSlice.reducer;
